module.exports = __webpack_public_path__ + "static/media/danger-info.419fe51b.svg";